var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.212 4.119l1.67 1.67-6.3 6.298-2.091.422.422-2.091 6.3-6.3zm0-1.65L.84 9.842 0 14l4.157-.839 7.375-7.373-3.32-3.32zm4.145 2.495L14 3.319 10.68 0 9.038 1.643l3.319 3.32z",
    fill: "url(#editIcon_svg__paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "editIcon_svg__paint0_linear",
    x1: 7.824,
    y1: 26.293,
    x2: 19.153,
    y2: 21.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#01D6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#218FEE"
  })))));
}

export default SvgEditIcon;